import { BaseService } from "./BaseService";
import {
    Department,
    DepartmentData,
    DepartmentDataOnly,
    DepartmentOrganizationMap,
} from "../models/Department";

class DepartmentServiceClass extends BaseService {
    protected get baseUrl(): string {
        return `${process.env.NEXT_PUBLIC_API_URL}/api/organization/`;
    }

    async getDepartments(): Promise<Department[]> {
        return this.get("GetDepartmentList");
    }

    async getDeparmentsByOrgId(orgId: number): Promise<Department[]> {
        return this.get(`GetDepartmentListForOrganization/${orgId}`);
    }

    async createDepartment(data: DepartmentDataOnly): Promise<number> {
        const response = (await this.post(
            "CreateDepartment",
            data,
            "text"
        )) as string;
        return parseInt(response, 10);
    }

    async updateDepartment(data: DepartmentData): Promise<Department> {
        return this.put(`UpdateDepartment/${data.departmentId}`, data, "text");
    }

    async deleteDepartment(id: number): Promise<void> {
        await this.delete(`DeleteDepartment/${id}`);
    }

    async createDepartmentOrganizationMap(data: DepartmentOrganizationMap) {
        return this.post(
            `CreateDepartmentOrganizationMap/${data.organizationId}/${data.departmentId}`
        );
    }
}

export const departmentService = new DepartmentServiceClass();
